import InAppMessagesService from "../../services/crud/InAppMessageService";
import { TableProps } from "./types";
import GenericItemsTable, { DefaultColumnMapper } from "./GenericItemsTable";
import { InAppMessageFormGenericForm } from "../forms/InAppMessageForm";
import InAppMessageListItem from "../../models/InAppMessageListItem";

async function load(): Promise<InAppMessageListItem[]> {

  const [inAppMessageList] = await Promise.all([
    InAppMessagesService.list(),
  ]);

  const list = inAppMessageList.map((m) => ({
    ...m,
    sentAtAsDate: (m as any).sentAtAsDate,
    viewedAtAsDate: (m as any).viewedAtAsDate,
    dismissedAtAsDate: (m as any).dismissedAtAsDate,
    expiresAtAsDate: (m as any).expiresAtAsDate,
  } as any));
  return list;
}

export const GenericInAppMessagesTable = ({ ...rest }: TableProps<InAppMessageListItem>) => {
  return (
    <GenericItemsTable
      name="InAppMessage"
      actions={{ select: true, edit: true, delete: true }}
      includeColumns={["toEmail", "title", "sentAtAsDate", "viewedAtAsDate", "dismissedAtAsDate", "expiresAtAsDate", "actions"]}
      model={InAppMessageListItem}
      form={InAppMessageFormGenericForm}
      formEdit={InAppMessageFormGenericForm}
      service={InAppMessagesService}
      leftButton={<></>}
      dataLoader={load}
      //columnMapper={(col) => {
      //  col = DefaultColumnMapper(col);
      //  return col;
      //}}
      {...rest}></GenericItemsTable>
  );
};

